import { Button as MuiButton } from '@mui/material';

export const Button = MuiButton;
